import { createResolver, } from '@spotify-internal/remote-config-core';
import { transportProvider } from '@spotify-internal/remote-config-provider-transport';
import { propertiesMiddleware } from '@spotify-internal/remote-config-middleware-properties';
import { exposureMiddleware } from '@spotify-internal/remote-config-middleware-exposure';
import { initialConfigMiddleware } from '@spotify-internal/remote-config-middleware-initial-config';
import { sptCookieMiddleware } from '@spotify-internal/remote-config-middleware-sptcookie';
export const ClientResolver = createResolver(transportProvider)
    .addMiddleware(propertiesMiddleware)
    .addMiddleware(initialConfigMiddleware)
    .addMiddleware(exposureMiddleware)
    .addMiddleware(sptCookieMiddleware);
//# sourceMappingURL=resolver-client.js.map